import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    if (JSON.parse(localStorage.getItem('serengetiSession')) && JSON.parse(localStorage.getItem('serengetiSession')).loggedIn) {
      return this.router.navigate(['/main']);
    } else {
      return true;
    }
  }

}
